var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke-width:1.5px;}.a,.b{stroke:#353841;}.b,.d{fill:none;}.b{stroke-linecap:round;stroke-width:2px;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 29.922)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6172.522,9218.057h39.044",
    transform: "translate(-6172.522 -9218.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6172.522,9218.057h39.044",
    transform: "translate(-6172.522 -9201.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6172.522,9218.057h5.438",
    transform: "translate(-6172.522 -9209.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6172.522,9218.057h5.438",
    transform: "translate(-6161.095 -9209.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6172.522,9218.057h5.438",
    transform: "translate(-6149.668 -9209.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6172.522,9218.057h5.438",
    transform: "translate(-6138.243 -9209.979)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreet);
export default __webpack_public_path__ + "static/media/street.a72b61c4a0d345c1c171d45f18783101.svg";
export { ForwardRef as ReactComponent };